import { Option } from 'effect';

import { toImageTemplate } from '@vs-shop/engine/image/ImageTemplate';
import type { ImageTemplate } from '@vs-shop/engine/image/ImageTemplate';

export type ProductImagePreview =
  | { readonly kind: 'available'; readonly template: ImageTemplate }
  | { readonly kind: 'missing' };

export const toProductImagePreview = (imagePath: string | null | undefined): ProductImagePreview =>
  Option.match(toImageTemplate(imagePath), {
    onNone: () => ({ kind: 'missing' }),
    onSome: (template) => ({ kind: 'available', template }),
  });
